import {createToggleSignal} from '@peachy/client-kit'
import {ManageMembersModal} from '../../../../components/ManageMembers/modal/ManageMembersModal'
import {Button} from '../../../../global/forms/Button'
import {useStore} from '../../../../providers/AccountSubscription/AccountSubscriptionProvider'
import styles from './QuoteFooter.module.css'
import {Show} from 'solid-js'

// TODO standardise footer at some point
export const QuoteFooter = () => {
    const [isEmployeeModalOpen, toggleEmployeeModal] = createToggleSignal(false)

    const store = useStore()

    const onOpen = () => {
        store.setFullValidation(true)

        if (!store.canPurchase()) {
            store.startEditing()
            toggleEmployeeModal()
            return
        }

    }

    const onClose = () => {
        toggleEmployeeModal()
        store.stopEditing()
    }

    return (
        <section class={styles.quoteFooter}>
            {/* https://teampeachy.atlassian.net/browse/DEV-720  */}
            {/* <PriceBreakdownModal/> */}
            <div/>
            {/* TODO show only when quote price available */}
            <Show when={store.getAccount()?.company}>
                <Button theme="light" onClick={onOpen}>Send to Customer for Review →</Button>
            </Show>
            <ManageMembersModal isOpen={isEmployeeModalOpen()} onDismiss={onClose} />
        </section>
    )
}
